import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

type Props = {
  children: ReactNode
  innerClassName?: string
}

/**
 * Shared layout wrapper for all settings pages.
 *
 * Every page — forms and tables alike — uses the same 720px column at a
 * fixed left gutter, so switching between settings pages never makes the
 * heading jump sideways or the content change width (design 15).
 * The wrapper fills the scroll area's height so a sticky save bar can dock
 * to the bottom of the viewport even on short pages.
 */
export function SettingsPageContainer({ children, innerClassName }: Props) {
  return (
    <div className="flex min-h-full w-full flex-col px-4 pt-8 pb-10 sm:px-8 md:px-14 md:pt-12">
      <div
        className={cn('flex w-full max-w-[720px] flex-1 flex-col', innerClassName)}
      >
        {children}
      </div>
    </div>
  )
}
